import mainTemplate from './views/wrapper.tpl.html';
import rsvpExportsTemplate from './views/rsvps.tpl.html';
import billingExportsTemplate from './views/billing.tpl.html';
import vouchersExportsTemplate from './views/vouchers.tpl.html';
import VouchersExportsController from './controllers/vouchers-controller';

angular
    .module('festzelt-os.exports')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.exports', {
            abstract: true,
            url: '/exports',
            templateUrl: mainTemplate,
            data: {
                showBackBtn: true,
                pageTitle: 'Exports'
            }
        })
        .state('app.exports.rsvps', {
            url: '/rsvps',
            data: {
                showBackBtn: false,
                view: 'export'
            },
            views: {
                export: {
                    templateUrl: rsvpExportsTemplate,
                    controller: 'RsvpExportsController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.exports.billing', {
            url: '/billing',
            data: {
                showBackBtn: false,
                view: 'export'
            },
            views: {
                export: {
                    templateUrl: billingExportsTemplate,
                    controller: 'BillingExportsController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('app.exports.vouchers', {
            url: '/vouchers',
            data: {
                showBackBtn: false,
                view: 'export'
            },
            views: {
                export: {
                    templateUrl: vouchersExportsTemplate,
                    controller: VouchersExportsController,
                    controllerAs: 'vm'
                }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/exports/exports-routes.js